import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DateBeforeValidatorOptions } from '../model';

export const dateBeforeValidator = (
  compareToControlName: string,
  options: DateBeforeValidatorOptions = {},
): ValidatorFn => {
  return (control: AbstractControl) => {
    const formGroup = control.parent;
    if (!formGroup) return null;

    const compareTo = formGroup.get(compareToControlName);
    if (!compareTo || !control.value || !compareTo.value) return null;

    const { minimumDifferenceInDays, dateLabel, compareToDateLabel } = options;
    const currentDate = new Date(control.value);
    const compareDate = new Date(compareTo.value);

    let message = $localize`:formError|The date must be the same as or before the end date@@dateNotAfterEndDate:${dateLabel || 'Datum'} mag niet na de ${compareToDateLabel ? compareToDateLabel.toLowerCase() : 'einddatum'} liggen.`;

    if (minimumDifferenceInDays) {
      compareDate.setDate(compareDate.getDate() - minimumDifferenceInDays);
      const minimumDifferenceInDaysText = `${minimumDifferenceInDays} dag${minimumDifferenceInDays > 1 ? 'en' : ''}`;
      message = $localize`:formError|The date must be the same as or before the end date@@dateNotAfterEndDateWithOffset:${dateLabel || 'Datum'} moet minimaal ${minimumDifferenceInDaysText} vóór de ${compareToDateLabel ? compareToDateLabel.toLowerCase() : 'einddatum'} liggen.`;
    }

    return currentDate <= compareDate
      ? null
      : {
          dateBefore: {
            message,
          },
        };
  };
};
